import { render } from "./DialogBox.vue?vue&type=template&id=23ca0da9"
import script from "./DialogBox.vue?vue&type=script&lang=js"
export * from "./DialogBox.vue?vue&type=script&lang=js"

import "./DialogBox.vue?vue&type=style&index=0&id=23ca0da9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__